import React, { useCallback } from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MapType } from "../../types/dataTypes";
import SquareCheckbox from "../Shared/SquareCheckbox";

type BaseLayerProps = {
  layer: { text: string; id: string };
  layerArray: { text: string; id: string, paint: {"line_color": string; "line_width": number;}; }[];
  map: MapType;
  selectedLayer: string;
  setSelectedLayer: React.Dispatch<React.SetStateAction<string>>;
};

function BaseLayerSelect({
  layer,
  layerArray,
  map,
  selectedLayer,
  setSelectedLayer,
}: BaseLayerProps) {
  const mapCurrent = map.current;

  const changeBaselayer = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      if (!mapCurrent) {
        return;
      }
      const layerId = e.currentTarget.value;
      setSelectedLayer(layerId);
      layerArray.forEach((layer) =>
        layer.id !== layerId
          ? mapCurrent.setLayoutProperty(layer.id, "visibility", "none")
          : setBasemap(layer)
      );
    },
    [layerArray, mapCurrent, setSelectedLayer]
  );

  function setBasemap(layer: any){
    if(mapCurrent != null){
      mapCurrent.setLayoutProperty(layer.id, "visibility", "visible")
      mapCurrent.setLayoutProperty('lineLayer', "visibility", layer.border_west_sahara)
      mapCurrent.setPaintProperty('lineLayer', 'line-color', layer.paint.line_color)
      mapCurrent.setPaintProperty('lineLayer', 'line-width', layer.paint.line_width)
    }
  }

  return (
    <SquareCheckbox
      checkboxId={layer.id}
      isCheckboxChecked={selectedLayer === layer.id}
      checkboxLabel={layer.text}
      onSelectCheckbox={changeBaselayer}
    />
  );
}

export default BaseLayerSelect;
